import slugify from 'slugify';

export default () => {
  const locale = document.querySelector('html').getAttribute('lang') || 'de';
  document.querySelectorAll('.toc-index').forEach((tocIndex) => {
    let target = tocIndex.dataset.contentElement;
    if ((!target) || (!document.querySelector(target))) {
      return;
    }
    let ul = document.createElement('ul');
    document.querySelectorAll(target).forEach((content) => {
      if (tocIndex.dataset.headlineSelector) {
        headlineSelector = tocIndex.dataset.headlineSelector;
      } else {
        headlineSelector = Array.from({ length: 9 }, (x, i) => 'h' + (i + 1) + '.toc-headline').join(', ');
      }
      content.querySelectorAll(headlineSelector).forEach((h) => {
        let a = document.createElement('a');
        let li = document.createElement('li');
        if (h.dataset.customLevel) {
          a.dataset.itemNumber = h.dataset.customLevel;
        } else {
          a.dataset.itemNumber = [h.dataset.firstLevel, h.dataset.secondLevel].filter((e) => !!e).join('.');
          if (!a.dataset.itemNumber.endsWith('.')) {
            a.dataset.itemNumber += '.';
          }
        }
        if (a.dataset.itemNumber === '.') {
          a.dataset.itemNumber = '•';
        }
        let levelNumber = a.dataset.itemNumber.split('.').filter((e) => !!e).length;
        a.textContent = h.textContent;

        if (!h.getAttribute('id')) {
          h.setAttribute('id', slugify(h.textContent, { locale, lower: true }));
        }

        a.setAttribute('href', `#${h.getAttribute('id')}`);
        li.classList.add(`level${levelNumber}`);
        li.appendChild(a);
        ul.appendChild(li);
      });
    });
    tocIndex.appendChild(ul);
    if (tocIndex.querySelector('ul li')) {
      // only display toc index if any items exists
      tocIndex.classList.add('visible');
    }
  });
}